import './guestMessage.scss';

export const GuestMessage = {
    template: `
        <div class="personalized-message" ng-if="$ctrl.header && $ctrl.message">
            <div class="flex-row baseline-row">
                <div class="column compress column-sm-12">
                    <h2>{{ $ctrl.header }}</h2>
                </div>
            </div>
            <div class="flex-row baseline-row">
                <div class="column compress column-sm-12">
                    {{ $ctrl.message }}
                </div>
            </div>
        </div>
    `,
    bindings: {
        currentDiningOption: '<'
    },
    controller: class {
        constructor(restaurantInfoFactory) {
            'ngInject';

            restaurantInfoFactory.getInfo(['onlineOrder']).then(info => {
                if (this.currentDiningOption === 'DELIVERY' && info.onlineOrder.hasDeliveryMessage) {
                    this.header = 'Delivery Information';
                    this.message = info.onlineOrder.deliveryMessage;
                }
                else if (this.currentDiningOption !== 'DELIVERY' && info.onlineOrder.hasPickupMessage) {
                    this.header = 'Pickup Information';
                    this.message = info.onlineOrder.pickupMessage;
                }
            });
        }
    }
};
